export const activeProject = {
  id: "PRJ-8842",
  title: "NEON-NIGHTS AW24",
  client: "CyberWear Inc.",
  date: "2024-11-15T18:00:00Z",
  status: "In Production",
  location: "Sector 4 Industrial Park, Warehouse B",
  brief: "High-contrast urban streetwear campaign. Focus on reflective materials, cyber-aesthetic, and practical neon ambient lighting. Gritty but polished.",
  deliverablesTracker: {
    total: 24,
    completed: 16,
    pendingReview: 4
  },
  shots: [
    { id: "S01", title: "Hero Wide - Entrance", angle: "Low angle, 14mm", lighting: "Red gel back, cold key", status: "done", image: "https://images.unsplash.com/photo-1605806616949-1e87b487cb2a?q=80&w=400&auto=format&fit=crop" },
    { id: "S02", title: "Jacket Detail - Reflective", angle: "Macro, 85mm", lighting: "Ring flash, underlit", status: "done", image: "https://images.unsplash.com/photo-1515940175183-6798529cb860?q=80&w=400&auto=format&fit=crop" },
    { id: "S03", title: "Action - Running", angle: "Tracking, 35mm", lighting: "Streetlamp ambient + strobe", status: "in-progress", image: "https://images.unsplash.com/photo-1555680202-c86f0e12f086?q=80&w=400&auto=format&fit=crop" },
    { id: "S04", title: "Portrait - Visor Up", angle: "Eye level, 50mm", lighting: "Neon tube practical", status: "pending", image: "https://images.unsplash.com/photo-1535295972055-1c762f4483e5?q=80&w=400&auto=format&fit=crop" },
    { id: "S05", title: "Group Shot - Alley", angle: "High angle, 24mm", lighting: "Overhead drone light", status: "pending", image: null },
  ],
  moodboard: [
    "https://images.unsplash.com/photo-1554629947-334ff61d85dc?q=80&w=600&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1573053677494-0d8b763ec7b6?q=80&w=600&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1618331835717-801e976710b2?q=80&w=600&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1519608487953-e999c86e7455?q=80&w=600&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?q=80&w=600&auto=format&fit=crop"
  ],
  logistics: {
    props: [
      { id: 1, item: "LED Visor", status: "packed", owner: "Studio" },
      { id: 2, item: "Smoke Machine (Heavy)", status: "rented", owner: "Rental Haus" },
      { id: 3, item: "Reflective Umbrellas x3", status: "packed", owner: "Studio" },
      { id: 4, item: "Cyber-Katana Prop", status: "missing", owner: "Client" }
    ],
    crew: [
      { role: "Photographer", name: "Alex Chen" },
      { role: "Lighting Tech", name: "Sarah Vance" },
      { role: "MUA", name: "Jax" }
    ]
  }
};